// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    projectId: 'vielo-sports',
    appId: '1:817387690225:web:61eb9fa88254c3510bf150',
    storageBucket: 'vielo-sports.appspot.com',
    locationId: 'europe-west',
    apiKey: 'AIzaSyDsZjXuCm5YBIxvjmFNfeZz1j-44dGhC_w',
    authDomain: 'vielo-sports.firebaseapp.com',
    messagingSenderId: '817387690225',
    measurementId: 'G-QGD8QVTDE6',
  }
};
